define('collections/calendar/nutrition/foods',[
    'underscore', 'backbone', 'utils', 'moment',
    // services
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // models
    'models/calendar/nutrition/food'
], function(
    // libs
    _, Backbone, U, moment,
    // services
    API,
    // super class
    InfiniteCollection,
    // model
    MFood
) {

    var CFoods = InfiniteCollection.extend({
        fetchDelay: 1,
        comparator: 'no_field',
        model: MFood,
        url: function() {
            return API.url("nutrition/food/" + (this.options.full ? 'full/' : ''));
        },
        state: {
            pageSize: 200,
        },

        queryParams: {
            database: function() {
                return this.options.database;
            },
            query: function() {
                return this.options.query || null;
            },
        },

        initialize: function(models, options) {
            options = this.options = _.extend({
                query: null,
                full: false,
            }, options);

            if (options.pageSize) this.state.pageSize = options.pageSize;

            var database = options.database;
            if (!_.isArray(database)) database = [database];
            // Add the custom  the database array option
            if (options.custom) database.push('null');

            options.database = database;

        },

        setQuery: function(query) {
            this.options.query = query;
            return this;
        },

        resetQuery: function() {
            this.setQuery();
            return this;
        },

        fetch: function(options) {
            options = options || {};
            if (this.isFetchDue() || options.force) {
                this.promise = CFoods.__super__.fetch.call(this, {
                    context: this,
                    success: this._onSync,
                    error: this._onError
                });
            }
            return this.promise;
        },

        isFetchDue: function() {
            var lastFetch = this.lastFetch,
                promise = this.promise,
                isPending = promise && promise.state() === "pending";

            return !isPending && !lastFetch || // not fetched yet?
                moment().diff(lastFetch, 'seconds') > this.fetchDelay; // is delay passed?
        },

        _onSync: function() {
            this.lastFetch = moment();
        },
        _onError: function() {
            this.lastFetch = null;
        },
    });

    return CFoods;
});

